//
import Model from '@/models/Model'

//
export default class SlCommissionType extends Model {

	/**
	 *
	 */
    resource() {
        return 'sl_commission_type'
    }
}